import type { ReactNode } from 'react'
import { Header } from './Header'

/** Simple shell (Header + centered content) for non-funnel pages (auth, bookings). */
export function PageShell({
  children,
  narrow,
  desktopWide,
}: {
  children: ReactNode
  narrow?: boolean
  /** Keep the mobile/tablet width, but widen to max-w-5xl from `lg` up (desktop-responsive). */
  desktopWide?: boolean
}) {
  const base = narrow ? 'max-w-md px-4 py-10 sm:px-6' : 'max-w-3xl px-4 py-8 sm:px-6'
  return (
    <div className="min-h-dvh bg-ink-50">
      <Header />
      <main className={`mx-auto ${base}${desktopWide ? ' lg:max-w-5xl' : ''}`}>{children}</main>
    </div>
  )
}
